import React from "react";
import { Autocomplete } from "@shopify/polaris";
import { KPI } from "../../constants/task";
import { reducerFn } from "../../helper";
import { ComponentLabelPolaris } from "./ComponentLabelPolaris";
import useTimeout from "../../hooks/useTimeout";

const KPI_OPTIONS = KPI.map((i) => ({ value: String(i), label: String(i) }));

export default function KPIV2({
  label,
  labelHidden,
  value,
  onChange,
  required,
}) {
  const [state, setState] = React.useReducer(reducerFn, {
    selected: value ? [value] : [],
    options: KPI_OPTIONS,
    inputValue: "",
  });

  React.useEffect(() => {
    if (!value) return;

    const selectedItem = KPI_OPTIONS.find((item) =>
      [value].includes(item.value),
    );
    if (selectedItem) {
      setState({ inputValue: selectedItem.label, selected: [value] });
    }
  }, [value]);

  const handleInputChange = React.useCallback((value) => {
    setState({ inputValue: value });
    const ptStr = getPattern(value);
    if (!value || !ptStr) {
      setState({ options: KPI_OPTIONS });
      return;
    }

    const pt = new RegExp(ptStr, "gi");
    const options = KPI_OPTIONS.filter((item) => !!item.label.match(pt));

    setState({ options });
  }, []);

  const [setDelay] = useTimeout();
  const handleOnChange = React.useCallback((selected) => {
    setState({ selected });

    const selectedItem = KPI_OPTIONS.find((item) =>
      selected.includes(item.value),
    );
    if (selectedItem) {
      setState({ inputValue: selectedItem.label });
    }

    setDelay(() => {
      if (onChange) {
        onChange(selected);
      }
    });
  }, []);

  const textField = (
    <Autocomplete.TextField
      placeholder="Choose KPI"
      value={state.inputValue}
      onChange={handleInputChange}
    />
  );

  return (
    <div>
      {labelHidden ? null : (
        <ComponentLabelPolaris label={label || "KPI"} required={required} />
      )}
      <Autocomplete
        options={state.options}
        onSelect={handleOnChange}
        selected={state.selected}
        textField={textField}
      />
    </div>
  );
}

function getPattern(str) {
  if (!!str.match(/[a-zA-Z]/gi)) return "";
  str = str.replace(/[\.\,]/, () => "\\.");
  return str;
}
